import { z } from "zod";

/**
 * Tool node config — stored in AgentExternalTool.node Json field.
 * Mirrors ToolActionConfigNode in shared/domain/tools/external-tool-config.ts.
 *
 * `properties`, `handledByAgent`, and `displays` are open-ended arrays defined
 * by each tool provider — their items vary per tool and cannot be narrowed further.
 */
export const ToolNodeConfigSchema = z
  .object({
    id: z.string().optional(),
    name: z.string(),
    description: z.string().nullable().optional(),
    /** Tool-provider-defined property descriptors */
    properties: z.array(z.unknown()),
    /** Current user-supplied value for the node (shape varies per tool) */
    userValue: z.unknown(),
    /** Fields to be filled in by the agent instead of the user */
    handledByAgent: z.array(z.unknown()),
    toolCredentialsId: z.string().nullable(),
    /** Display configuration (shape varies per tool) */
    displays: z.array(z.unknown())
  })
  .nullable();

export type ToolNodeConfig = z.infer<typeof ToolNodeConfigSchema>;
